import { TranslationService } from "../../services/TranslationService";
import VerticalMenu from "../shared/components/VerticalMenu";
import TabPosition from "../shared/TabPosition";
import { DataPersonal } from "./components/DataPersonal";
import { DataPlan } from "./components/DataPlan";
import { CompanyConfiguration } from "./components/CompanyConfiguration";
import { DataPersonalInvoice } from "./components/DataPersonalInvoice";
import { addIf } from "../../utils/Utils";
import CompanyService from "../../services/CompanyService";
import { DataHistoryInvoice } from "./components/DataHistoryInvoice";
import { Helmet } from "react-helmet";

const Profile: React.FC = () => {
    const tabs = [
        { title: TranslationService.translate.DataPersonal, component: DataPersonal },
        ...addIf(
            CompanyService.getCompanyToken()?.userid === CompanyService.getCompanyToken()?.ownerId,
            { title: TranslationService.translate.DataPlan, component: DataPlan }
        ),
        { title: TranslationService.translate.InvoicingData, component: DataPersonalInvoice },
        { title: TranslationService.translate.InvoiceHistory, component: DataHistoryInvoice },
        { title: TranslationService.translate.Preferences, component: CompanyConfiguration },
    ];
    return (
        <TabPosition module="Profile">
            <Helmet>
                <title>Intiza</title>
            </Helmet>
            <VerticalMenu items={tabs} title={TranslationService.translate.MyAccount} />
        </TabPosition>
    );
};

export default Profile;
